import {useCallback} from "react";
import {BaseQueryApi} from "@reduxjs/toolkit/query";
import {ImportType} from "../model/import-type";
import {OtsAsyncThunkConfigExtra, OtsState} from "../store/ots-store";
import {removeUndefined} from "../util/util";
import {extractFileName} from "../web/util/web-utils";
import {buildStandardHeaders} from "../store/ots-api";

export type UseDownloadImportTemplateProps = {
  baseQueryApi: BaseQueryApi
}

export type UseDownloadImportTemplateResult = {
  downloadImportTemplate: (importType: ImportType) => void
}

export const useDownloadImportTemplate = (props: UseDownloadImportTemplateProps): UseDownloadImportTemplateResult => {
  const {baseQueryApi} = props

  const _downloadImportTemplate = useCallback((importType: ImportType) => {
    const headers = buildStandardHeaders(baseQueryApi)

    const request: RequestInit = {
      method: 'GET',
      headers: headers
    }

    const baseUrl = (baseQueryApi.extra as OtsAsyncThunkConfigExtra).baseUrl;
    const url = `${baseUrl}/templates/import/${importType.template}`;
    window.fetch(url, request)
      .then((response) => {
        const fileName = extractFileName(response)
        response.headers.forEach((h) => console.debug(h))
        response.blob()
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName ?? new Date().getTime().toString()
            a.click();
          })
          .catch((rejected) => {
            // do nothing
          })
          .finally(() => {
            // do nothing
          })
      })
      .catch((rejected) => {
        // do nothing
      })
  }, [baseQueryApi])

  return {
    downloadImportTemplate: _downloadImportTemplate,
  }
}
